const ADMIN_REPLAY_LAUNCH_KEY = "v3tax:admin_replay_launch";
const PREVIEW_EXCHANGE_IMPORTS_KEY = "preview_exchange_imports";

function parseDatasetIdFromPath(pathname = "") {
  const match = String(pathname).match(/\/analyze\/(\d+)/);
  return match ? Number(match[1]) : null;
}

function tryParseJson(raw) {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

function readStoredLaunchPayload() {
  try {
    const fromLocal = tryParseJson(localStorage.getItem(ADMIN_REPLAY_LAUNCH_KEY));
    if (fromLocal) return fromLocal;
  } catch {
    /* ignore */
  }

  try {
    return tryParseJson(sessionStorage.getItem(ADMIN_REPLAY_LAUNCH_KEY));
  } catch {
    return null;
  }
}

export function readPreviewExchangeImports() {
  try {
    const raw =
      localStorage.getItem(PREVIEW_EXCHANGE_IMPORTS_KEY) ||
      sessionStorage.getItem(PREVIEW_EXCHANGE_IMPORTS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function writePreviewExchangeImports(rows = []) {
  const payload = JSON.stringify(Array.isArray(rows) ? rows : []);
  try {
    localStorage.setItem(PREVIEW_EXCHANGE_IMPORTS_KEY, payload);
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.setItem(PREVIEW_EXCHANGE_IMPORTS_KEY, payload);
  } catch {
    /* ignore */
  }
}

export function readAdminReplayLaunch(options = {}) {
  const search =
    options.search ??
    (typeof window !== "undefined" ? window.location.search : "");
  const pathname =
    options.pathname ??
    (typeof window !== "undefined" ? window.location.pathname : "");

  const urlDatasetId = parseDatasetIdFromPath(pathname);
  const stored = readStoredLaunchPayload();

  if (stored && (!urlDatasetId || Number(stored.datasetId) === urlDatasetId)) {
    return stored;
  }

  if (!isAdminReplayUrl(search)) return null;

  const params = new URLSearchParams(search);
  const year = Number(params.get("year"));
  if (!Number.isFinite(year)) return null;

  return {
    autorun: params.get("autorun") || null,
    datasetId: urlDatasetId,
    year,
    selectedCountry: String(params.get("country") || "DE").toUpperCase(),
    isPreview: params.get("preview") === "1",
    previewExchangeRows: readPreviewExchangeImports(),
    adminReplay: {
      sourceDatasetId: params.get("sourceDataset")
        ? Number(params.get("sourceDataset"))
        : null,
      sourceUserWallet: params.get("sourceUser") || null,
      sourceActivityEventId: params.get("sourceEvent")
        ? Number(params.get("sourceEvent"))
        : null,
      warnings: [],
    },
  };
}

export function stripAdminReplayAutorunParams(search = "") {
  const params = new URLSearchParams(search);
  params.delete("autorun");
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export function writeAdminReplayLaunch(payload) {
  const json = JSON.stringify(payload);
  try {
    localStorage.setItem(ADMIN_REPLAY_LAUNCH_KEY, json);
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.setItem(ADMIN_REPLAY_LAUNCH_KEY, json);
  } catch {
    /* ignore */
  }
}

export function clearAdminReplayLaunch() {
  try {
    localStorage.removeItem(ADMIN_REPLAY_LAUNCH_KEY);
  } catch {
    /* ignore */
  }
  try {
    sessionStorage.removeItem(ADMIN_REPLAY_LAUNCH_KEY);
  } catch {
    /* ignore */
  }
}

export function isAdminReplayUrl(search = "") {
  try {
    return new URLSearchParams(search).get("adminReplay") === "1";
  } catch {
    return false;
  }
}

export function getAdminReplayAutorunMode(search = "", pathname = "") {
  if (!isAdminReplayUrl(search)) return null;

  const fromUrl = new URLSearchParams(search).get("autorun");
  if (fromUrl === "calc" || fromUrl === "view") return fromUrl;

  return null;
}

export function openAdminReplayAnalysis(prepareResult) {
  const {
    adminDatasetId,
    year,
    selectedCountry,
    isPreview,
    exchangeImportsRows = [],
    source = {},
    warnings = [],
  } = prepareResult || {};

  if (!adminDatasetId || !year) {
    throw new Error("Invalid admin replay payload");
  }

  const launchPayload = {
    autorun: "calc",
    datasetId: Number(adminDatasetId),
    year: Number(year),
    selectedCountry: selectedCountry || "DE",
    isPreview: !!isPreview,
    previewExchangeRows: Array.isArray(exchangeImportsRows) ? exchangeImportsRows : [],
    adminReplay: {
      sourceDatasetId: source.sourceDatasetId || null,
      sourceUserWallet: source.sourceUserWallet || null,
      sourceActivityEventId: source.sourceActivityEventId || null,
      warnings: Array.isArray(warnings) ? warnings : [],
    },
  };

  writeAdminReplayLaunch(launchPayload);
  writePreviewExchangeImports(launchPayload.previewExchangeRows);

  const qs = new URLSearchParams({
    year: String(year),
    adminReplay: "1",
    autorun: "calc",
    country: launchPayload.selectedCountry,
  });
  if (launchPayload.isPreview) qs.set("preview", "1");
  if (source.sourceDatasetId) qs.set("sourceDataset", String(source.sourceDatasetId));
  if (source.sourceUserWallet) qs.set("sourceUser", source.sourceUserWallet);
  if (source.sourceActivityEventId) {
    qs.set("sourceEvent", String(source.sourceActivityEventId));
  }

  const url = `/analyze/${encodeURIComponent(String(adminDatasetId))}?${qs.toString()}`;
  const win = window.open(url, "_blank");
  if (!win) {
    clearAdminReplayLaunch();
    throw new Error("popup_blocked");
  }
}
